import { DiagnosisCategoryType } from '@/models/diagnosis';
import { ROUTES } from '@/types/common';

const DIET_TREATMENT_ID = '12';
const MEDICINE_UNIT_ID = 185;
const DEFAULT_REGION_CODE = 11;

export const getCategoryPath = (categoryId: string, categoryType: DiagnosisCategoryType): string => {
  if (categoryType === DiagnosisCategoryType.Treatment && categoryId === DIET_TREATMENT_ID) {
    return `${ROUTES.NON_BENEFIT.HOME.path}?treatmentId=${categoryId}&treatmentMedicineUnitId=${MEDICINE_UNIT_ID}&regionCode=${DEFAULT_REGION_CODE}`;
  }

  return `${ROUTES.TELEMEDICINE.REQUEST.path}?categoryId=${categoryId}&type=${categoryType}`;
};
